/* eslint-disable */

import currency from "./currency";
import { getCreditCardType } from "./creditCardUtils";

const masks = {
  cpf(cpf) {
    cpf = cpf.replace(/\D/g, "");
    cpf = cpf.replace(/(\d{3})(\d)/, "$1.$2");
    cpf = cpf.replace(/(\d{3})(\d)/, "$1.$2");
    cpf = cpf.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
    return cpf;
  },

  cnpj(cnpj) {
    cnpj = cnpj.replace(/\D/g, "");
    cnpj = cnpj.replace(/^(\d{2})(\d)/, "$1.$2");
    cnpj = cnpj.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
    cnpj = cnpj.replace(/\.(\d{3})(\d)/, ".$1/$2");
    cnpj = cnpj.replace(/(\d{4})(\d)/, "$1-$2");
    return cnpj;
  },

  cep(cep) {
    cep = cep.replace(/\D/g, "");
    cep = cep.replace(/^(\d{5})(\d)/, "$1-$2");
    return cep;
  },

  date(dateMask) {
    return dateMask
      .replace(/\D/g, "")
      .replace(/(\d{2})(\d)/, "$1/$2")
      .replace(/(\d{2})(\d)/, "$1/$2");
  },

  phone(phoneMask) {
    return phoneMask.length > 10
      ? phoneMask
          .replace(/\D/g, "")
          .replace(/^(\d)/, "($1")
          .replace(/^(\(\d{2})(\d)/, "$1) $2")
          .replace(/(\d{5})(\d{1,4})/, "$1-$2")
          .replace(/(-\d{4})\d+?$/, "$1")
      : phoneMask
          .replace(/\D/g, "")
          .replace(/^(\d)/, "($1")
          .replace(/^(\(\d{2})(\d)/, "$1) $2")
          .replace(/(\d{4})(\d{1,5})/, "$1-$2")
          .replace(/(-\d{5})\d+?$/, "$1");
  },

  numberOnly(value) {
    return value.replace(/\D/g, "");
  },

  currency(value) {
    value = value.replace(/\D/g, "").replace(",", "").split(".").join("");
    return value === "" ? "" : currency.numberToCurrency(value / 100);
  },

  creditValidity(value) {
    return value.replace(/\D/g, "").replace(/(\d{2})(\d)/, "$1/$2");
  },

  creditCard(value) {
    const creditNumber = value.replace(/\D/g, "");
    switch (getCreditCardType(creditNumber).name) {
      case "Visa":
        if (creditNumber.length > 13) {
          return creditNumber
            .substr(0, 16)
            .replace(/(\d{4})(\d{4})(\d{4})(\d)/, "$1.$2.$3.$4");
        } else {
          return creditNumber
            .replace(/(\d{4})(\d)/, "$1.$2")
            .replace(/(\d{4}\.\d{3})(\d)/, "$1.$2")
            .replace(/(\d{4}\.\d{3}.\d{3})(\d)/, "$1.$2");
        }
        break;

      case "Amex":
        return creditNumber
          .substr(0, 15)
          .replace(/(\d{4})(\d)/, "$1.$2")
          .replace(/(\d{4}\.\d{6})(\d)/, "$1.$2");
        break;

      case "Hipercard":
        if (creditNumber.length > 16) {
          return creditNumber
            .substr(0, 19)
            .replace(/(\d{6})(\d{4})(\d{5})(\d)/, "$1.$2.$3.$4");
        } else if (creditNumber.length <= 13) {
          return creditNumber
            .replace(/(\d{4})(\d)/, "$1.$2")
            .replace(/(\d{4}\.\d{4})(\d)/, "$1.$2")
            .replace(/(\d{4}\.\d{4}.\d{2})(\d)/, "$1.$2");
        }
        break;

      default:
        return creditNumber
          .substr(0, 16)
          .replace(/(\d{4})(\d)/, "$1.$2")
          .replace(/(\d{4}\.\d{4})(\d)/, "$1.$2")
          .replace(/(\d{4}\.\d{4}.\d{4})(\d)/, "$1.$2");
    }
    return value;
  },
};

export default masks;
